import { Fragment, lazy } from "react";
import { Route } from "react-router-dom";
import { routes } from "@/config/routes";
import ProtectedRoute from "./ProtextedRoute";
import { UserRole } from "@/types";

const ECLogin = lazy(() => import("@/pages/ec/Login"));
const ECProjects = lazy(() => import("@/pages/ec/Projects"));
const ECProjectDetails = lazy(() => import("@/pages/ec/ProjectDetails"));
const ECOrders = lazy(() => import("@/pages/ec/Orders"));
const ECOrderDetails = lazy(() => import("@/pages/ec/OrderDetails"));
const ECOrderPay = lazy(() => import("@/pages/ec/OrderPay"));
const ECPaymentMethods = lazy(() => import("@/pages/ec/PaymentMethods"));
const ECDocuments = lazy(() => import("@/pages/ec/Documents"));

const EndCustomerRoutes = (
  <Fragment>
    <Route path={routes.ec.login} element={<ECLogin />} />
    <Route
      path={routes.ec.projects}
      element={
        <ProtectedRoute requiredRoles={[UserRole.END_CUSTOMER]}>
          <ECProjects />
        </ProtectedRoute>
      }
    />
    <Route
      path={routes.ec.projectDetails}
      element={
        <ProtectedRoute requiredRoles={[UserRole.END_CUSTOMER]}>
          <ECProjectDetails />
        </ProtectedRoute>
      }
    />
    <Route
      path={routes.ec.orders}
      element={
        <ProtectedRoute requiredRoles={[UserRole.END_CUSTOMER]}>
          <ECOrders />
        </ProtectedRoute>
      }
    />
    <Route
      path={routes.ec.orderDetails}
      element={
        <ProtectedRoute requiredRoles={[UserRole.END_CUSTOMER]}>
          <ECOrderDetails />
        </ProtectedRoute>
      }
    />
    <Route
      path={routes.ec.orderPay}
      element={
        <ProtectedRoute requiredRoles={[UserRole.END_CUSTOMER]}>
          <ECOrderPay />
        </ProtectedRoute>
      }
    />
    <Route
      path={routes.ec.paymentMethods}
      element={
        <ProtectedRoute requiredRoles={[UserRole.END_CUSTOMER]}>
          <ECPaymentMethods />
        </ProtectedRoute>
      }
    />
    <Route
      path={routes.ec.documents}
      element={
        <ProtectedRoute requiredRoles={[UserRole.END_CUSTOMER]}>
          <ECDocuments />
        </ProtectedRoute>
      }
    />
  </Fragment>
);

export default EndCustomerRoutes;
